import React from 'react'

export default function StepProgress({ step, totalSteps, label }) {
  return (
    <div className="mb-8">
      <p className="text-xs font-semibold text-primary tracking-wide mb-3">
        STEP {step + 1} OF {totalSteps} &bull; {label}
      </p>
      <div className="flex gap-2">
        {
          Array.from({ length: totalSteps }).map((_, index) => (
            <div key={index} className={`h-1.5 flex-1 rounded-full ${index <= step ? 'bg-primary' : 'bg-default'}`} />
          ))
        }
      </div>
    </div>
  )
}
